import React from 'react'
import { useDispatch } from 'react-redux'
import { SubmissionError } from 'redux-form'
import { useHistory } from 'react-router-dom'

import { signup } from '../../ducks/users'
import Button from '../Shared/Button'
import AuthPage from '../Shared/AuthPage'
import SignupForm from './SignupForm'

export default function Signup() {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleSignup = async data => {
    try {
      await dispatch(signup(data))
      history.push('/setup/profile')
    } catch (err) {
      throw new SubmissionError({
        _error:
          'An unknown error occurred. ' +
          'Please check your information and try again.',
      })
    }
  }

  return (
    <AuthPage
      links={
        <Button text to="/login">
          Already have an account? Login
        </Button>
      }
    >
      <SignupForm onSubmit={handleSignup} />
    </AuthPage>
  )
}
